import React from 'react';
import styled from '@emotion/styled';
import fn12 from 'assets/images/fn-12.png';
import fn15 from 'assets/images/fn-15.png';
import PageHero from 'components/PageHero';
import { H2, H3 } from 'components/typography';
import Image from 'next/image';

const Wrapper = styled.div`
  display: flex;
  min-height: calc(100vh - 400px);

  @media (max-width: ${({ theme }) => theme.breakPoints.mobile}) {
    flex-direction: column;
  }
`;

const Section = styled.div`
  background: ${({ background }) => background};
  color: ${({ theme }) => theme.palette.GREEN};
  text-align: center;
  padding: 70px 25px;
`;

const ImgWrapper = styled.div`
  margin: 25px 10px;
`;

const Hallbarhet = () => (
  <div style={{ height: '100%' }}>
    <PageHero
      title="Hållbarhet"
      text="Med Digito vid er sida skapar vi en mer hållbara verksamhet"
    />
    <Wrapper>
      <Section>
        <H2>Mål 12: Hållbar konsumtion och produktion.</H2>
        <ImgWrapper>
          <Image
            src={fn12}
            alt="fn12"
            layout="fixed"
            width={200}
            height={200}
            placeholder="blur"
          />
        </ImgWrapper>
        <H3>
          Omställning till en hållbar konsumtion och produktion av varor är en
          nödvändighet för att minska vår negativa påverkan på klimat och miljö.
          <br />
          <br />
          Därför lyder vårt motto – Vi är inte i mål förrän visitkorten är i
          mobilen istället för papperskorgen.
        </H3>
      </Section>
      <Section background="#e9d3b8">
        <H2>Mål 15: Ekosystem och biologisk mångfald.</H2>
        <ImgWrapper>
          <Image
            src={fn15}
            alt="fn15"
            layout="fixed"
            width={200}
            height={200}
            placeholder="blur"
          />
        </ImgWrapper>
        <H3>
          Hållbara ekosystem och biologisk mångfald är grunden för vårt liv på
          jorden. Därför har vi valt att plantera nya träd runtom i världen.
        </H3>
      </Section>
    </Wrapper>
  </div>
);

Hallbarhet.layoutOptions = {
  fullHeight: true,
  footer: true,
  noBottomSpacing: true
};

export default Hallbarhet;
